import React from "react";
import { PlusOutlined, PrinterOutlined, FileExcelOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";

import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

import CoachEntry from "../../components/masters/coach/CoachEntry";
import CoachList from "../../components/masters/coach/CoachList";
import { DEFAULT_MASTER_DRAWER_WIDTH, EXTRAA_LARGE_MASTER_DRAWER_WIDTH, LARGE_MASTER_DRAWER_WIDTH } from "../../utility/Constants";
import DrawableCloseIcon from "../../components/common/DrawableCloseIcon";
import commonUtility from "../../utility/Utils";
import { ALL_COACH_XLS_URL } from "../../utility/URL";





function Coach() {
  const [visible, setVisible] = useState(false);
  const [coachAddData, setCoachAddData] = useState({
    coach_id: 0,
    coach_name: '',
    mobile: '',
    whatsapp: '',
    address: '',
    // coach_amount: 0,
    // bta_amonut: 0,
    // coaching_fee: 0,
    is_active: 'Y',
    mode: "ADD",
    coach_detail: [],
    designation: '',
    coach_work_status: '',
    certification: '',
  });

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };


  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Coach"
          subTitle=""
          extra={[
            <Button key="1" className="custom-button-white" shape="round" onClick={showDrawer} style={{ border: 0 }}>
              <PlusOutlined /> Add
            </Button>,

            <Button key="2" className="custom-button-white" shape="round" onClick={() => commonUtility.openInNewTab("http://btaportal.in/custom/report/member/print_coach_pdf/1")}>
              <PrinterOutlined /> Print
            </Button>,

            <Button key="3" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(ALL_COACH_XLS_URL)}>
              <FileExcelOutlined /> Excel
            </Button>,

          ]}
        ></PageHeader>

        <Drawer
          title="Add new coach"
          width={EXTRAA_LARGE_MASTER_DRAWER_WIDTH}
          onClose={onClose}
          visible={visible}
          bodyStyle={{
            paddingBottom: 80,
          }}
          destroyOnClose={true}
          closeIcon={<><DrawableCloseIcon /></>}
        >
          <CoachEntry data={coachAddData} onDrawerClose={onClose} />
        </Drawer>

        <div className="tableView nestedTable">
          <div className="form-content">
            <CoachList />
          </div>
        </div>

      </div>
    </div>
  );
}

export default Coach